import React from 'react';
import { Link } from 'react-router-dom';

export default function Breadcrumb({ items }) {
  return (
    <nav className="react-breadcrumb" aria-label="breadcrumb">
      <ol>
        {items.map((item, i) => (
          <li key={i} className={i === items.length - 1 ? 'active' : ''}>
            {item.link ? <Link to={item.link}>{item.label}</Link> : item.label}
          </li>
        ))}
      </ol>
    </nav>
  );
}
